import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '@/lib/auth';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { LogIn, ArrowLeft, Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const user = await login(username, password);
    setLoading(false);
    if (user) {
      toast.success('Logged in successfully');
      navigate('/admin/dashboard');
    } else {
      toast.error('Invalid username or password');
    }
  };

  return (
    <div className="min-h-[100dvh] bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-2 text-[#0057B7]/40 hover:text-[#0057B7] text-sm mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Back to site
        </Link>

        <div className="text-center mb-8">
          <h1 className="font-heading text-2xl font-bold text-[#0057B7]">
            <span className="text-[#FFDD00]">ADMIN</span> LOGIN
          </h1>
          <p className="text-[#0057B7]/40 text-sm mt-2">Sign in to access the admin portal</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#E8F0FE] rounded-xl p-6 space-y-5 border border-[#0057B7]/5">
          <div className="space-y-2">
            <Label className="text-[#0057B7]/80 text-sm">Username</Label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              autoComplete="username"
              className="h-11 bg-white border-[#0057B7]/10 text-[#0057B7]"
            />
          </div>

          <div className="space-y-2">
            <Label className="text-[#0057B7]/80 text-sm">Password</Label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="current-password"
                className="h-11 bg-white border-[#0057B7]/10 text-[#0057B7] pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#0057B7]/40 hover:text-[#0057B7]/60"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-primary justify-center disabled:opacity-50"
          >
            <LogIn className="w-4 h-4" />
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <p className="text-xs text-[#0057B7]/30 text-center">
            Default: admin / admin123
          </p>
        </form>
      </div>
    </div>
  );
}